import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
import { debugReport } from "@/api/auth/onlineUser";
import { getInfo } from "@/api/user";
import util from '@/libs/util';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var d;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.i18nHandle(_this.$i18n.locale);

              setTimeout(function () {
                util.cookies.get('token') && _this.$store.dispatch('d2admin/serchSelect/setGame');

                if (util.cookies.get('token')) {
                  _this.$store.dispatch('d2admin/account/updUserInfo');
                }
              }, 500); // util.cookies.get('token') && this.$store.dispatch('d2admin/serchSelect/setGame')
              // 用户名称为空退出登录

              _context.next = 4;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.info',
                user: true
              });

            case 4:
              d = _context.sent;

              _this.reporting();

              if (JSON.stringify(d) === '{}') {
                _this.logout();
              } // 环境判断


              if (process.env.NODE_ENV === "development") {// this.control()
              } else {
                _this.control();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout', 'reporting'])), {}, {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    },
    controlTow: function controlTow() {},
    control: function control() {
      var that = this;
      var isQuery = false;
      setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (function () {})["constructor"]("debugger")(); // check()

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 1000);
    }
  })
};